/* CL - Tour: fechas + sombreros (22-sep-2026). Ver sections/cl-tour.liquid
 *
 * - Talla + «Agregar» sin salir de la página: /cart/add.js y luego el atributo
 *   de carrito `origen: tour` (queda en el pedido). Dispara `ajaxProduct:added`,
 *   el mismo evento del tema, que abre el carrito lateral y actualiza la burbuja.
 * - Barra fija (celular) que lleva al módulo de sombreros.
 * - Al volver de la boletera: hoja (celular) o panel (escritorio) con el sombrero,
 *   una sola vez por visita.
 */
(function () {
  'use strict';

  var KEY_SALIDA = 'clTourSalida';
  var KEY_VISTA = 'clTourHojaVista';

  function ss(fn) {
    try { return fn(window.sessionStorage); } catch (e) { return null; }
  }

  function rutas() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add') + '.js',
      upd: (r.cart_update_url || '/cart/update') + '.js'
    };
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (j) {
        if (!res.ok) throw new Error(j.description || j.message || ('HTTP ' + res.status));
        return j;
      });
    });
  }

  function elegirTalla(chip) {
    var card = chip.closest('[data-cl-gorro]');
    card.querySelectorAll('.cl-gorro__tallas button').forEach(function (b) {
      b.setAttribute('aria-pressed', b === chip ? 'true' : 'false');
    });
    var btn = card.querySelector('[data-cl-agregar]');
    btn.disabled = false;
    btn.classList.remove('is-hecho', 'is-error');
    btn.textContent = btn.dataset.txtAgregar + ' · ' + chip.dataset.precio;
  }

  function agregar(btn, alTerminar) {
    if (btn.classList.contains('is-hecho') || btn.disabled) return;
    var card = btn.closest('[data-cl-gorro]');
    var sel = card.querySelector('.cl-gorro__tallas [aria-pressed="true"]');
    var variante = sel ? sel.dataset.variant : btn.dataset.variant;
    if (!variante) return;

    var r = rutas();
    btn.disabled = true;
    btn.classList.remove('is-error');
    btn.textContent = btn.dataset.txtAgregando;

    postJSON(r.add, { items: [{ id: Number(variante), quantity: 1 }] })
      .then(function () {
        // Marca del origen: si falla, la compra sigue; solo se pierde la medición.
        return postJSON(r.upd, { attributes: { origen: 'tour' } }).catch(function (e) {
          console.warn('cl-tour: no se pudo marcar origen', e);
        });
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.add('is-hecho');
        btn.textContent = btn.dataset.txtHecho + (sel ? ' · ' + btn.dataset.txtTalla + ' ' + sel.textContent.trim() : '');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        if (alTerminar) alTerminar();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.classList.add('is-error');
        btn.textContent = btn.dataset.txtError;
        console.error('cl-tour:', err);
      });
  }

  function clicTarjeta(e, alTerminar) {
    var chip = e.target.closest('.cl-gorro__tallas button');
    if (chip) {
      if (!chip.disabled) elegirTalla(chip);
      return true;
    }
    var add = e.target.closest('[data-cl-agregar]');
    if (add) {
      agregar(add, alTerminar);
      return true;
    }
    return false;
  }

  function marcarSalida(ciudad) {
    ss(function (st) {
      if (!st.getItem(KEY_VISTA)) st.setItem(KEY_SALIDA, JSON.stringify({ c: ciudad, t: Date.now() }));
    });
  }

  function initHoja(hoja) {
    if (!hoja) return;
    document.body.appendChild(hoja);
    var titulo = hoja.querySelector('.cl-tour-hoja__t');

    function abrir(ciudad) {
      titulo.textContent = (hoja.dataset.titulo || '').replace('[ciudad]', ciudad || '').replace(/\s+\?/, '?');
      hoja.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { hoja.classList.add('is-open'); });
      });
    }
    function cerrar() {
      hoja.classList.remove('is-open');
      setTimeout(function () { hoja.hidden = true; }, 400);
    }

    hoja.addEventListener('click', function (e) {
      if (e.target.closest('[data-cl-cerrar-hoja]')) { cerrar(); return; }
      clicTarjeta(e, function () { setTimeout(cerrar, 900); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !hoja.hidden) cerrar();
    });

    function revisarVuelta() {
      var s = ss(function (st) { return JSON.parse(st.getItem(KEY_SALIDA) || 'null'); });
      if (!s) return;
      var dt = Date.now() - s.t;
      if (dt < 2500) return; // volvió enseguida: todavía no compró nada
      ss(function (st) { st.removeItem(KEY_SALIDA); st.setItem(KEY_VISTA, '1'); });
      if (dt > 30 * 60 * 1000) return; // pasó demasiado tiempo
      abrir(s.c);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') revisarVuelta();
    });
    window.addEventListener('pageshow', revisarVuelta);
    revisarVuelta();
  }

  function initBarra(barra, modulo) {
    if (!barra || !modulo || !('IntersectionObserver' in window)) return;
    document.body.appendChild(barra);
    barra.hidden = false;
    var moduloVisible = false;

    function actualizar() {
      var hojaAbierta = !!document.querySelector('.cl-tour-hoja.is-open');
      barra.classList.toggle('is-visible', !moduloVisible && !hojaAbierta);
    }
    new IntersectionObserver(function (ents) {
      moduloVisible = ents[0].isIntersecting;
      actualizar();
    }, { threshold: 0.05 }).observe(modulo);
    window.addEventListener('scroll', actualizar, { passive: true });
    barra.querySelector('[data-cl-ir-sombreros]').addEventListener('click', function () {
      modulo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    actualizar();
  }

  function init(root) {
    if (root.dataset.clListo) return;
    root.dataset.clListo = '1';

    root.addEventListener('click', function (e) {
      if (clicTarjeta(e)) return;
      var bol = e.target.closest('.cl-show__boletos[href]');
      if (bol) marcarSalida(bol.dataset.ciudad || '');
    });

    // En el editor del tema no se mueven la barra ni la hoja al <body>.
    if (window.Shopify && window.Shopify.designMode) return;
    initBarra(root.querySelector('[data-cl-barra]'), root.querySelector('[data-cl-sombreros]'));
    initHoja(root.querySelector('[data-cl-hoja]'));
  }

  function arrancar() {
    document.querySelectorAll('[data-cl-tour]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
